import _ from "lodash";

// A neighbour that is out of range (undefined), 0 or NaN falls back to the note itself.
const noteOrFallback = (note: number | undefined, fallback: number) =>
  note === undefined || note === 0 || Number.isNaN(note) ? fallback : note;

export const findClosestNote = (notes: number[], v: number) => {
  const si_ = _.sortedIndex(notes, v);
  const si = Math.min(si_, notes.length - 1);
  const o0 = noteOrFallback(notes[si - 1], notes[si]);
  const o1 = notes[si];
  const o2 = noteOrFallback(notes[si + 1], notes[si]);
  const diff0 = Math.abs(o0 - v);
  const diff1 = Math.abs(o1 - v);
  const diff2 = Math.abs(o2 - v);
  if (diff0 < diff1 && diff0 < diff2) {
    return o0;
  }
  return diff1 < diff2 ? o1 : o2;
};
